module.exports = __webpack_public_path__ + "static/media/policy.45a33fa1.md";